import { render, staticRenderFns } from "./ProfileMainPage.vue?vue&type=template&id=5937211c&scoped=true&"
import script from "./ProfileMainPage.vue?vue&type=script&lang=js&"
export * from "./ProfileMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5937211c",
  null
  
)

export default component.exports